<template>
  <div class="form-label">
    {{ name }}
    <div v-if="isRequired" style="color: red;">
      &nbsp;*
    </div>
  </div>
</template>
<script lang="ts">
  export default {
    props: {
      name: {
        type: String,
        default: ''
      },
      isRequired: {
        type: Number,
        default: 0
      }
    },
  }
</script>
<style lang="scss">
.form-label {
  width: 100px;
  padding-bottom: 8px;
  margin-right: 8px;
  overflow-wrap: break-word;
  word-break: normal;
}
</style>
